import React from 'react'
import { Button, Card, Carousel, CarouselItem, Col, Row } from 'react-bootstrap'

const HomeOffice = () => {
    
  return (
    <>
        <div id="home-office" className="container home-office-container">
            <Row >
                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}}>
                    <Card className='no-border rounded-0'>
                        <Card.Title className='home-office-main-title'> ホームオフィス </Card.Title>
                        <Card.Text className='home-office-text-content text-left'>
                        パンデミック時には、オフィス内のデスクから自宅でのリモートワークへと環境が変化しました。私たちはクライアントのホームオフィスのデジタルツインを、ヘッドセットやApple Watchといったデジタル機器に至るまで、細部までこだわって制作しました。
                        </Card.Text>
                        <Button className='home-office-360-button btn btn-warning'><a href="/jp/krpano-player" ><img className='img-fluid threesixty-icon' src={"/assets/icons/360.png"} alt="360 icon" />360°で見る</a></Button>
                    </Card>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:8, offset:0}} className="home-office-slider-container">
                    <Carousel className='home-office-carousel' indicators={false} interval={null} >
                        <CarouselItem className='home-office-carousel-item'>
                            <Card className='no-border rounded-0'>
                                <Row>
                                    <Col xs={{span:4, offset:1}}>
                                        <Card.Img className='home-office-first-image' src={"/assets/digital-twin/home-office/Seperated/office01.jpg"}  alt="" />
                                    </Col>
                                    <Col xs={{span:6, offset:0}}>
                                        <Card.Img className='' src={"/assets/digital-twin/home-office/Seperated/office01_1.jpg"}  alt="" />
                                    </Col>

                                    <Col xs={{span:4, offset:1}}>
                                        <Card.Text className='home-office-carousel-title'> 現実世界のホームオフィス <br /> （参考写真）</Card.Text>
                                    </Col>
                                    <Col xs={{span:6, offset:0}}>
                                        <Card.Text className='home-office-carousel-title'> 仮想空間（VR）のホームオフィス <br /> （3Dモデルのレンダリング画像）</Card.Text>
                                    </Col>
                                </Row>
                            </Card>
                        </CarouselItem>
                        <CarouselItem className='home-office-carousel-item-middle'>
                            <Card className='no-border rounded-0'>
                                <Row>
                                    <Col xs={{span:6, offset:3}}>
                                        <Card.Img className='' src={"/assets/digital-twin/home-office/Seperated/office03_1.jpg"}  alt="" />
                                    </Col>
                                </Row>
                            </Card>
                        </CarouselItem>
                        <CarouselItem className='home-office-carousel-item'>
                            <Card className='no-border rounded-0'>
                                <Row>
                                    <Col xs={{span:4, offset:1}}>
                                        <Card.Img className='home-office-first-image' src={"/assets/digital-twin/home-office/Seperated/office02.jpg"}  alt="" />
                                    </Col>
                                    <Col xs={{span:6, offset:0}}>
                                        <Card.Img className='' src={"/assets/digital-twin/home-office/Seperated/office02_1.jpg"}  alt="" />
                                    </Col>
                                    <Col xs={{span:4, offset:1}}>
                                        <Card.Text className='home-office-carousel-title'> 現実世界のホームオフィス <br /> （参考写真）</Card.Text>
                                    </Col>
                                    <Col xs={{span:6, offset:0}}>
                                        <Card.Text className='home-office-carousel-title'> 仮想空間（VR）のホームオフィス <br /> （3Dモデルのレンダリング画像）</Card.Text>
                                    </Col>
                                </Row>
                            </Card>
                        </CarouselItem>
                    </Carousel>
                </Col>
            </Row>
        </div>
        
    </>
  )
}

export default HomeOffice
